import type { ComponentType } from 'react'
import type { IconProps } from '../create-icon'
import { GameController } from '../gaming/GameController'
import { CounterStrikeLogo } from '../brands/CounterStrikeLogo'
import { Dota2Logo } from '../brands/Dota2Logo'
import { LeagueOfLegendsLogo } from '../brands/LeagueOfLegendsLogo'
import { OverwatchLogo } from '../brands/OverwatchLogo'
import { PUBGLogo } from '../brands/PUBGLogo'
import { ValorantLogo } from '../brands/ValorantLogo'

// Keyed by the game's name or slug with everything but letters and digits
// dropped, so "League of Legends", "league-of-legends" and "leagueoflegends"
// all land on the same mark.
const MARKS: Record<string, ComponentType<IconProps>> = {
  leagueoflegends: LeagueOfLegendsLogo,
  valorant: ValorantLogo,
  counterstrike: CounterStrikeLogo,
  counterstrike2: CounterStrikeLogo,
  cs2: CounterStrikeLogo,
  dota2: Dota2Logo,
  pubg: PUBGLogo,
  overwatch: OverwatchLogo,
  overwatch2: OverwatchLogo,
}

function keyFor(game: string): string {
  return game.toLowerCase().replace(/[^a-z0-9]/g, '')
}

export interface GameMarkProps extends IconProps {
  /** The game's name or slug. */
  game: string
}

/**
 * A game's mark in one colour — `currentColor` unless `color` says otherwise —
 * so a row of games reads as one set instead of a run of mismatched logos.
 * A game without a mark of its own gets the generic controller, in the same
 * colour, rather than a gap.
 */
export function GameMark({ game, ...props }: GameMarkProps) {
  const Mark = MARKS[keyFor(game)] ?? GameController
  return <Mark {...props} />
}
